
function formatDate(dateString) {
  // Parse the date string into a Date object
  const date = new Date(dateString);

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June', 
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  // Get the month, day, and year
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Return formatted date string
  return `${month} ${day}, ${year}`;
}


const allPlanImages = document.querySelectorAll('.planimg');
const benefitCol = document.querySelectorAll('.benefitcol');

  
const options = {
  method: 'GET',
  headers: {
    accept: 'application/json',
    'content-type': 'application/json'
  }
};

fetch(`https://loyalty.yotpo.com/api/v2/customers?guid=TTEoljN_q6WzwFGJxu4fiA&api_key=SnyVL0zIA2C0ryFa0BIbvgtt&customer_id=${customerid}&country_iso_code=null&with_referral_code=false&with_history=true`, options)
  .then(response => response.json())
  .then(data => {

        console.log("data", data);
  
        // Extract points balance from response
         const pointsBalance = data?.points_balance; // Adjust based on actual response structure

        // // Display points balance
         let pointsBalanceElement = document.querySelector('.curntpont span');
         let totalEarned = document.querySelector('.totlpont h1 span');
         let mamberdate = document.querySelector('.totlpont > p span');

          let currentTir = document.querySelector('.curnttir h2');

           let normalmage = document.querySelector('.normal-mem');
           let eliteimg = document.querySelector('.elite-mem');
           let vipimage = document.querySelector('.vip-mem');

          // you're here
           let activebagmem = document.querySelector('.activebag-mem');
           let activebagelit = document.querySelector('.activebag-elit');
           let activebagvip = document.querySelector('.activebag-vip');

    
         let upgradetier = document.querySelector('.updrdtext h3 span');

    
         pointsBalanceElement.textContent = pointsBalance !== undefined ? pointsBalance : 'Points balance not available';
         totalEarned.textContent = data.points_earned;
         let daterow = data.history_items[0].date;
         const formattedDate = formatDate(daterow);
         mamberdate.textContent = formattedDate;

        const vipTierName = data.vip_tier_name;

        benefitCol.forEach(img => img.style.opacity = '0.4');

    
        if (vipTierName === "Elite") {
          currentTir.textContent = "Skin Enthusiast";
          allPlanImages.forEach(img => img.style.display = 'none');
          eliteimg.style.display = 'block';
          activebagelit.style.display = 'block';

        let activeplan = [...benefitCol].find(col => col.classList.contains("benefits-elite"));
          activeplan.style.opacity = '1';
          
        } else if (vipTierName === "VIP") {
          currentTir.textContent = "Skin Exprt";
           allPlanImages.forEach(img => img.style.display = 'none');
           vipimage.style.display = 'block';
           activebagvip.style.display = 'block';

          let activeplan = [...benefitCol].find(col => col.classList.contains("benefits-vip"));
          activeplan.style.opacity = '1';
          
        } else {
          currentTir.textContent = "Member";
          activebagmem.style.display = 'block';
          let activeplan = [...benefitCol].find(col => col.classList.contains("benefits-member"));
          activeplan.style.opacity = '1';
        }

        let amountNeed = data.vip_tier_upgrade_requirements.amount_cents_needed;
        const amountInDollars = amountNeed / 100;
        const formattedAmount = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(amountInDollars);
    
        upgradetier.textContent = `by spending ${formattedAmount} more`;

    
      })
  .catch(err => console.error(err));



  